// extracted by mini-css-extract-plugin
var _1 = "X8ALE";
export { _1 as "form" }
